<template>
	<el-container>
		<el-header height="115px">
			<div class="headerView">
				<img :src="src" style="width: 280px;height:60px;" alt="">
				<div class="headerViewLine"></div>
				<p>QC大赛申报</p>
			</div>
		</el-header>
		<el-main>
			<div class="newMid" :style="{height:newHeight+'px',background: bgc}" v-if="view">
				<div class="loginView">
					<div class="normalHead">
						<div :class="[selectIndex == index ?'normalActive':'','normalHead_view']"
							v-for="(item,index) in navList" :key="index" @click="selectType(item,index)">
							<p>{{item.label}}</p>
						</div>
					</div>
					<!-- <span>用户登录</span> -->
					<div class="innerView">
						<el-input v-model="userName" placeholder="请输入账号" prefix-icon="el-icon-user"></el-input>
						<el-input v-model="passWord" placeholder="请输入密码" type="password" prefix-icon="el-icon-lock"
							style="margin-top: 20px;"></el-input>
					</div>
					<el-button type="primary" class="specialBtn" @click="submitLogin">立即登录</el-button>
					<div class="login_inner" v-show="selectIndex == 0">
						<p @click="$router.push('/registerQc')" v-if="IsRegister">立即注册</p>
						<p style="margin: 0 20px;" v-if="IsRegister">|</p>
						<p @click="$router.push('/forget')">忘记密码</p>
						<p style="margin: 0 20px;">|</p>
						<p @click="caozuo">操作手册</p>
					</div>
					<div class="login_inner" v-show="selectIndex == 1">
						<p>忘记密码可联系管理员处理</p>
					</div>
				</div>
			</div>
		</el-main>
		<el-footer height="110px">
			<p>该平台由杭州新中大科技股份有限公司提供技术支持</p>
			<p>业务咨询热线：0311-68050809 技术咨询热线：025-52881988 | 浙ICP备05021872号-12</p>
		</el-footer>
	</el-container>
</template>

<script>
	import {
		userLogin,
		getCompony
	} from "@/api/moudles/user.js"
	import CryptoJs from 'crypto-js'
	export default {
		data() {
			return {
				userName: '',
				passWord: '',
				loading: false,
				checked: false,
				IsRegister: false,
				newHeight: 740,
				newTop: 140,
				src: "../../assets/img/login/logo.png",
				bgc: '',
				selectIndex: 0,
				navList: [{
						label: '申报单位登录',
						link: ''
					},
					// {
					// 	label: '推荐单位登录',
					// 	link: ''
					// }, 
					// {
					// 	label: '专家登录',
					// 	link: ''
					// },
				],

				typeId: '',
				typeName: '',
				view: true
			}
		},
		mounted() {
			window.onresize = () => (() => {
				const screenWidth = document.body.clientWidth;
				// console.log('screenWidth', screenWidth)
				if (screenWidth > 1210) {
					this.newHeight = screenWidth / 2.6
				}
			})();

			this.getCompony()

			let type = this.getQueryParams()

			if(type != 'qcHb'){
				this.$notify.error({
					title: '网址错误',
					message: '网址错误'
				});
				return
			}
			if(type == 'qcHb'){
				this.typeId   = 11
				this.typeName = 'QC小组'
				localStorage.setItem('typeKey', this.typeId)
			}

		},
		methods: {

			caozuo(){
				window.open('http://hbjxadmin.a6edu.com/adminapi/static/%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8C.pdf')
			},
			/**
			 * 解密
			 */
			decrypt(word) {
				let key = CryptoJs.enc.Utf8.parse("1234567890ABCDEF");
				let decrypt = CryptoJs.AES.decrypt(word, key, {
					mode: CryptoJs.mode.ECB,
					padding: CryptoJs.pad.Pkcs7
				});
				return CryptoJs.enc.Utf8.stringify(decrypt).toString();
			},

			getQueryParams() {
				let url = window.location.href; //获取当前url
				let dz_url = url.split('#')[0]; //获取#/之前的字符串
				let cs = dz_url.split('?')[1]; //获取?之后的参数字符串
				if(typeof cs =="undefined"){
					this.$notify.error({
						title: '网址错误',
						message: '网址错误'
					});
					return
				}
				let cs_arr = cs.split('&'); //参数字符串分割为数组
				return cs_arr[0].slice(5) //这样就拿到了参数中的数据
			},

			// 选择类型
			selectType(item, index) {
				if (item.link) {
					window.open(item.link)
				} else {
					this.selectIndex = index
				}
			},
			// 获取企业平台后缀
			async getCompony() {
				await getCompony({
					data: {},
					success: res => {
						this.IsRegister = res.data.is_register
						if (res.data.expert_url) {
							this.navList = [{
								label: '申报单位登录',
								link: ''
							}, {
								label: '推荐单位登录',
								link: ''
							}, {
								label: '专家登录',
								link: 'http://' + res.data.expert_url
							}]

						}
						 if (res.data.apply_mode == 1) {
						 	if (this.typeId == '') {
						 		this.$message({
						 			message: '申报网址不正确',
						 			type: 'error'
						 		});
						 		this.view = false
						 	}
						 }
						localStorage.setItem('cityChoose', res.data.city_choose)
						this.src = res.data.logo_img
						this.bgc = `url(${res.data.login_path}) left bottom / cover no-repeat`
					}
				})
			},

			async submitLogin() {
				const params = {
					username: this.userName.trim(),
					password: this.passWord.trim(),
					loginRole: this.selectIndex
				}
				if (!params.username || !params.password) {
					this.$notify.error({
						title: '错误',
						message: '账号或密码未输入'
					});
					return
				}
				this.loading = true
				await userLogin({
					data: params,
					success: (res) => {
						console.log('登录', res)
						this.loading = false
						if (res.code != 200) {
							this.$notify.error({
								title: '登录失败',
								message: res.msg
							});
							return
						}
						this.$message({
							message: '登录成功',
							type: 'success'
						});
						setTimeout(() => {
							localStorage.setItem('token', res.data.token)
							localStorage.setItem('userName', res.data.name)
							localStorage.setItem('userLevel', res.data.level)
							localStorage.setItem('userCompany', res.data.enp_name)
							localStorage.setItem('isRegister', res.data.is_register)
							localStorage.setItem('loginRoleId', res.data.loginRole)
							localStorage.setItem('project_config', JSON.stringify(res.data
								.project_config))

							this.$router.push('/index')

						}, 1000)
					},
					fail: (err) => {
						this.loading = false
						this.$notify.error({
							title: '登录失败',
							message: err
						});
					}
				})
			}
		}
	}
</script>

<style scoped>
	.normalHead {
		width: 100%;
		height: 70px;
		border: 2px solid #1476ca;
		margin-bottom: 30px;
		box-sizing: border-box;
		display: flex;
	}

	.normalHead_view {
		flex: 1;
		line-height: 70px;
		font-size: 18px;
		color: #1476ca;
		cursor: pointer;
	}

	.normalActive {
		background-color: #1476ca;
		color: #fff;
	}

	.el-header {
		color: #333;
	}

	.el-footer {
		padding: 20px 0;
		color: #333;
		text-align: center;
		line-height: 30px;
	}

	.el-aside {
		background-color: #D3DCE6;
		color: #333;
		text-align: center;
		line-height: 200px;
	}

	.el-main {
		padding: 0;
		background-color: #B3C0D1;
		color: #333;
		text-align: center;
	}

	body>.el-container {
		margin-bottom: 40px;
	}

	.el-container:nth-child(5) .el-aside,
	.el-container:nth-child(6) .el-aside {
		line-height: 260px;
	}

	.el-container:nth-child(7) .el-aside {
		line-height: 320px;
	}

	.el-button {
		border-radius: 0;
	}

	.headerView {
		display: flex;
		height: 115px;
		align-items: center;
		margin-left: 16%;
	}

	.newMid {
		position: relative;

	}

	@media screen and (max-width: 1236px) {
		.loginView {
			position: absolute;
			right: 10%;
			top: 0%;
			height: 465px;
			width: 440px;
			background-color: #ffffff;
		}
	}

	@media screen and (min-width: 1236px) and (max-width: 1280px) {
		.loginView {
			position: absolute;
			right: 10%;
			top: 2%;
			height: 465px;
			width: 440px;
			background-color: #ffffff;
		}
	}

	@media screen and (min-width: 1280px) and (max-width: 1400px) {
		.loginView {
			position: absolute;
			right: 10%;
			top: 5%;
			height: 465px;
			width: 440px;
			background-color: #ffffff;
		}
	}

	@media screen and (min-width: 1400px) and (max-width: 1600px) {
		.loginView {
			position: absolute;
			right: 10%;
			top: 10%;
			height: 465px;
			width: 440px;
			background-color: #ffffff;
		}
	}

	@media screen and (min-width: 1600px) {
		.loginView {
			position: absolute;
			right: 10%;
			top: 20%;
			height: 465px;
			width: 440px;
			background-color: #ffffff;
		}
	}

	/* 条件编译 */

	.loginView span {
		height: 98px;
		line-height: 98px;
		font-size: 28px;
		font-weight: 500;
		display: inline-block;
	}

	.loginView button {
		width: 370px;
		height: 60px;
		margin: 60px 0;
		letter-spacing: 2px;
		font-size: 16px;
	}

	.innerView {
		width: 370px;
		margin: 0 auto;
	}

	>>>.innerView input {
		height: 60px;
	}

	.headerViewLine {
		margin: 0 20px 0 35px;
		height: 60px;
		width: 1px;
		background-color: #ccc;
	}

	.headerView p {
		font-size: 26px;
		font-weight: 500;
	}

	/* 用户登录 */
	.userLogin {
		margin-left: auto;
		margin-top: 15%;
		margin-right: auto;
		width: 700px;
		height: 410px;
		display: flex;
		border-radius: 10px;
		background-color: #ffffff;
	}

	.userLogin .loginLeft {
		width: 48%;
		border-radius: 10px 0 0 10px;
		overflow: hidden;
	}

	.userLogin .loginRight {
		width: 52%;
		border-radius: 0 10px;
		padding: 30px 40px;
		box-sizing: border-box;
	}

	.rightTop {
		height: 25%;
		width: 100%;
		color: #015AAA;
		display: flex;
		flex-flow: column;
	}

	.rightBot {
		height: 75%;
		width: 100%;
	}

	.specialBtn {
		margin-top: 50px;
		width: 100%;
		height: 40px;
		background: #1476ca;
	}

	.login_inner {
		display: flex;
		justify-content: center;
		/* height: 55px; */
		align-items: center;
	}

	.login_inner p {
		display: inline-block;
		color: #015AAA;
		font-size: 14px;
		font-weight: 500;
		cursor: pointer;
	}
</style>
